export const batteryType = {
    discharge: { class: 'ty_1', text: 'device.discharge' },
    charge: { class: 'ty_2', text: 'device.charge' },
    wait: { class: 'ty_3', text: 'device.standby' },
};
